import { useCallback, useEffect, useMemo, useState } from 'react';

const WELCOME_MODAL_STORAGE_KEY = 'aa_dashboard_welcome_modal_seen';

interface UseWelcomeModalResult {
    shouldShowWelcome: boolean;
    markWelcomeAsSeen: () => void;
    showWelcomeModal: () => void;
}

export const useWelcomeModal = (projectId?: string): UseWelcomeModalResult => {
    const [shouldShowWelcome, setShouldShowWelcome] = useState<boolean>(false);

    const storageKey = useMemo(
        () => (projectId ? `${WELCOME_MODAL_STORAGE_KEY}_${projectId}` : null),
        [projectId],
    );

    useEffect(() => {
        if (typeof localStorage === 'undefined' || !storageKey) {
            return;
        }

        const hasSeenWelcome = localStorage.getItem(storageKey);
        if (!hasSeenWelcome) {
            const timer = setTimeout(() => {
                setShouldShowWelcome(true);
            }, 500);
            return () => clearTimeout(timer);
        }
    }, [storageKey]);

    const markWelcomeAsSeen = useCallback(() => {
        if (typeof localStorage === 'undefined' || !storageKey) {
            return;
        }

        localStorage.setItem(storageKey, 'true');
        setShouldShowWelcome(false);
    }, [storageKey]);

    const showWelcomeModal = useCallback(() => {
        setShouldShowWelcome(true);
    }, []);

    return {
        shouldShowWelcome,
        markWelcomeAsSeen,
        showWelcomeModal,
    };
};
